import styled, { css } from 'styled-components';
import { respondTo } from '@legacy-vfuk/core-mixins';

export const ArticleCardGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;

  ${respondTo.md(
    css`
      grid-template-columns: 1fr 1fr;
    `
  )}

  ${respondTo.lg(
    css`
      grid-template-columns: 1fr 1fr 1fr;
    `
  )}
`;
